import { render, staticRenderFns } from "./FormQuizzQuestions.vue?vue&type=template&id=ccf8afb4&scoped=true&"
import script from "./FormQuizzQuestions.vue?vue&type=script&lang=js&"
export * from "./FormQuizzQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzQuestions.vue?vue&type=style&index=0&id=ccf8afb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf8afb4",
  null
  
)

export default component.exports